<template>
  <section class="brands container">
    <h2 v-text="data.title" />

    <div v-if="page.other_brands" class="brands__List">
      <div v-for="item in page.other_brands" class="brands__Item brandBackgroundColor" :class="[useCamelCase(item.theme_class)]">
        <nuxt-link :to="item.sef">{{ item.name }}</nuxt-link>
        <div class="brands__ItemImage">
          <Flare :srcset="item.image" size="both" width="250" height="320" crop="fill" gravity="faces" :alt="item.image" />
        </div>
        
        <div class="brands__ItemBottom">
          <Flare :srcset="item.logo" class="brands__ItemLogo" size="both" width="260" :alt="item.logo" />
          <p v-text="item.description" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const { page } = usePage();
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_brands.scss');
</style>